export const Dogs = [
    {
        name: 'Bertie',
        href: '/jack',
        description: 'Tiny grumpy cockapoo',
        emoji: '😡',
        mainImage: '/img/jack/3.jpg',
        features: [
            { name: 'Full name', description: 'Bertie' },
            { name: 'Breed', description: 'Cockapoo' },
            { name: 'Owner', description: 'Jack' },
            { name: 'Colour', description: 'Black with white streaks' },
            { name: 'Likes', description: 'Food' },
            { name: 'Dislikes', description: 'Jack' }
        ],
        images: [
            '/img/jack/1.jpg',
            '/img/jack/2.jpg',
            '/img/jack/3.jpg',
            '/img/jack/3.jpg'
        ]
    },
    {
        name: 'Chip',
        href: '/dylan',
        description: 'Chipolata sausage puppy',
        emoji: '🌭',
        mainImage: '/img/dylan/3.jpg',
        features: [
            { name: 'Full name', description: 'Chip' },
            { name: 'Breed', description: 'Sausage Dog' },
            { name: 'Owner', description: 'Dylan' },
            { name: 'Colour', description: 'Chocolate' },
            { name: 'Likes', description: 'Destroying toys' },
            { name: 'Dislikes', description: 'The postman' }
        ],
        images: [
            '/img/dylan/1.jpg',
            '/img/dylan/2.jpg',
            '/img/dylan/3.jpg',
            '/img/dylan/3.jpg'
        ]
    },
    {
        name: 'Reggie',
        href: '/sarah',
        description: 'idk',
        emoji: '😎',
        mainImage: '/img/sarah/3.jpg',
        features: [
            { name: 'Full name', description: 'regginald' },
            { name: 'Breed', description: 'Shih Tzu' },
            { name: 'Owner', description: 'Sarah' },
            { name: 'Colour', description: 'white and brown and black ' },
            { name: 'Likes', description: 'being alone' },
            { name: 'Dislikes', description: 'cats' }
        ],
        images: [
            '/img/sarah/1.jpg',
            '/img/sarah/2.jpg',
            '/img/sarah/3.jpg',
            '/img/sarah/3.jpg'
        ]
    },
    {
        name: 'Jasper',
        href: '/cammy',
        description: 'idk',
        emoji: '💤',
        mainImage: '/img/cammy/1.jpg',
        features: [
            { name: 'Full name', description: 'Grand high jasper the 14th of Buckinghamshire' },
            { name: 'Breed', description: 'Cockapoo' },
            { name: 'Owner', description: 'Cammy' },
            { name: 'Colour', description: 'latte ' },
            { name: 'Likes', description: 'blood of infants' },
            { name: 'Dislikes', description: 'life' }
        ],
        images: [
            '/img/cammy/1.jpg',
            '/img/cammy/1.jpg',
            '/img/cammy/1.jpg',
            '/img/cammy/1.jpg'
        ]
    }
]
